<script>
	import { Paint } from "../../Map/MapLayerStyles";
	import MenuItem from "../FlyoutMenu/MenuItem.svelte";
	
	// Look at the Heatmap colors (MapLayerStyles.js) and build a gradient.
	const heatmapPaintStyle = Paint.heatmap;
	const amountColors = (heatmapPaintStyle["heatmap-color"].length - 3)/2 // 0.0
	const startIndex = 3;

	let gradientString = "";
	gradientString += "linear-gradient(";
	gradientString += "	to right,";
	for(let i = 0; i < amountColors; i++) {
		const percentage = Math.round(heatmapPaintStyle["heatmap-color"][startIndex + (i*2)] * 100);
		const color = heatmapPaintStyle["heatmap-color"][startIndex + (i*2) + 1];
		gradientString += color + " " + percentage + "%" + ((i != amountColors-1)?",":"");
	}
	gradientString += ")";

	// let iconArrow = `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>`;

	// let iconArrowB64 = `<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yMS44ODMgMTJsLTcuNTI3IDYuMjM1LjY0NC43NjUgOS03LjUyMS05LTcuNDc5LS42NDUuNzY0IDcuNTI5IDYuMjM2aC0yMS44ODR2MWgyMS44ODN6Ii8+PC9zdmc+">`;

	let iconArrowB64Raw = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yMS44ODMgMTJsLTcuNTI3IDYuMjM1LjY0NC43NjUgOS03LjUyMS05LTcuNDc5LS42NDUuNzY0IDcuNTI5IDYuMjM2aC0yMS44ODR2MWgyMS44ODN6Ii8+PC9zdmc+";

</script>


<style type="text/css">
	.heatmap-key-gradient {
		width:calc(100% - 2px);
		height:40px;
		border-radius: 2px;
		border:1px solid #666;
		background-image: var(--background);
	}
</style>

<MenuItem title={"Heatmap Key"} materialIcon={"whatshot"}>
	<div class='heatmap-key-gradient' style="--background:{gradientString}"></div>
	<p style="text-align:center;">Increasing number of position updates <img src={iconArrowB64Raw} alt="arrow" style="vertical-align:middle;"/></p>
</MenuItem>
